<template>
  <loading :show="show">
    <b-modal
      header-bg-variant="header-modal-js"
      header-text-variant="light"
      footer-bg-variant="light"
      ref="modal-select-empresa"
      id="modal-select-empresa"
      size="lg"
      :title="titulo ? titulo : 'Selecionar empresa'"
      no-close-on-backdrop
      hide-footer
    >

      <div class="container-fluid">

        <!-- BUSCA -->
        <div class="row mb-3">
          <div class="col-md-10">
            <b-form-input
              v-model="termo"
              placeholder="Digite o nome da empresa"
              @keyup.enter="buscar"
            />
          </div>
          <div class="col-md-2">
            <b-button variant="primary" class="w-100" @click="buscar">
              Buscar
            </b-button>
          </div>
        </div>

        <!-- ESTADOS -->
        <div v-if="termo && termo.length > 0 && termo.length < 3" class="text-center text-muted mt-4">
          Digite pelo menos 3 caracteres para buscar
        </div>
        <div v-if="!buscou && !loading" class="text-center text-muted mt-5">
          Digite o nome da empresa para buscar
        </div>

        <div v-if="loading" class="text-center mt-5">
          <b-spinner label="Carregando..."></b-spinner>
        </div>

        <div v-if="buscou && !loading && empresas.length === 0" class="text-center text-muted mt-5">
          Nenhuma empresa encontrada
        </div>

        <!-- LISTA -->
        <div class="row">
          <div
            v-for="empresa in empresas"
            :key="empresa.id"
            class="col-md-6 mb-3"
          >
            <div class="card card-empresa" @click="selecionar(empresa)">
              <div class="d-flex align-items-center p-3">

                <img
                  :src="empresa.logo"
                  class="logo-empresa mr-3"
                  @error="onImgError"
                />

                <div>
                  <div class="nome-empresa">{{ empresa.nome }}</div>
                  <div class="identificador text-muted">
                    {{ empresa.identificador }}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

      </div>

    </b-modal>
  </loading>
</template>

<script>
import AgendaService from '@/service/AgendaService'; // ajuste se necessário
import Loading from '../../layout/Loading';

export default {
  components: { Loading },
  props: ['titulo'],

  data() {
    return {
      show: false,
      termo: '',
      empresas: [],
      loading: false,
      buscou: false
    }
  },

  methods: {

    async buscar() {
      if (!this.termo || this.termo.trim().length < 3) {
        this.empresas = []
        this.buscou = false
        return
      }

      this.loading = true
      this.buscou = true

      try {
        let dadosConsulta = {
          nome: this.termo
        }

        const resposta = await AgendaService.buscaEmpresaCredenciamento(dadosConsulta)

        this.empresas = resposta.data.obj || []

      } catch (err) {
        this.empresas = []
      } finally {
        this.loading = false
      }
    },

    selecionar(empresa) {
      this.$emit('selecionou', {
        status: 'success',
        empresa
      })
      this.fechar()
    },

    abrir() {
      this.reset()
      this.$bvModal.show('modal-select-empresa')
    },

    fechar() {
      this.$bvModal.hide('modal-select-empresa')
    },

    reset() {
      this.termo = ''
      this.empresas = []
      this.loading = false
      this.buscou = false
    },

    onImgError(e) {
      e.target.src = 'https://via.placeholder.com/50x50?text=Logo'
    }
  }
}
</script>

<style scoped>

.card-empresa {
  cursor: pointer;
  border-radius: 10px;
  transition: all 0.2s ease;
  border: 1px solid #e9ecef;
}

.card-empresa:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  border-color: #007bff;
}

.logo-empresa {
  width: 50px;
  height: 50px;
  object-fit: contain;
  border-radius: 6px;
  background: #fff;
  border: 1px solid #eee;
}

.nome-empresa {
  font-weight: 600;
  font-size: 14px;
}

.identificador {
  font-size: 12px;
}

</style>